import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';

import { Provider } from 'react-redux';
import store from './state/store';
import { resizeWindow } from './state/responsive';
/*
import { authData } from './lib/login';
import { AuthContext } from './contexts';
*/

import { Router } from './components/Router';
//import { LoginContainer } from './containers/Login';
import { AlertContainer } from './containers/Alerts';

/*
import { IndexPage } from './pages/home';
import { LoginPage } from './pages/login';
import { CalendarPage } from './pages/calendar';
import { EventDetailsPage } from './pages/calendar/event-details';
import { EventEditorPage } from './pages/calendar/event-editor';
import { LedgerPage } from './pages/treas/ledger';
import { TransactionPage } from './pages/treas/transaction';
import { PendingLedgerPage } from './pages/treas/pending-ledger';
import { PendingTransactionPage } from './pages/treas/pending-transaction';
import { FECSchedulePage } from './pages/treas/fec-schedule';
import { FECFilingPage } from './pages/treas/fec-filing';
import { TreasurerReportPage } from './pages/treas/monthly-report';
import { ReconcilePage } from './pages/treas/reconcile';
import { BoardAdminPage } from './pages/admin/board';
import { MembershipPage } from './pages/admin/membership';
import { MemberAdminPage } from './pages/admin/member';
import { AttendancePage } from './pages/admin/meeting-attendance';
import { BlogIndexPage } from './pages/blog/index';
import { BlogStoryPage } from './pages/blog/story';
import { BlogPostPage } from './pages/blog/post';

import { ElectionAdminPage } from './pages/admin/endorsements/election';
import { OfficeTypeAdminPage } from './pages/admin/endorsements/office-type';
import { OfficeAdminPage } from './pages/admin/endorsements/office';
import { OfficeHolderAdminPage } from './pages/admin/endorsements/office-holder';
import { CandidacyAdminPage } from './pages/admin/endorsements/candidacy';
import { CandidateEndorsementPage } from './pages/admin/endorsements/candidate-endorsement';
*/

/*
import { AttendancePage } from './pages/attendance';
import { BoardPage } from './pages/board';
import { EventDetailsPage } from './pages/event-details';
import { LedgerPage } from './pages/ledger';
import { MemberPage } from './pages/member';
import { MembershipPage } from './pages/membership';
import { ReportPage } from './pages/report';
import { PendingPage } from './pages/pending';
import { PendingListPage } from './pages/pending-list';
import { FECPage } from './pages/fec';
import { ReconcilePage } from './pages/reconcile';
*/
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import './style/common.css';
import './style/fec.css';
import './style/mobile.css';

/*
const pages = {
  index: IndexPage,
  login: LoginPage,
  calendar: CalendarPage,
  'calendar/event-details': EventDetailsPage,
  'calendar/event-editor': EventEditorPage,
  'treas/ledger': LedgerPage,
  'treas/transaction': TransactionPage,
  'treas/pending-ledger': PendingLedgerPage,
  'treas/pending-transaction': PendingTransactionPage,
  'treas/fec-schedule': FECSchedulePage,
  'treas/fec-filing': FECFilingPage,
  'treas/monthly-report': TreasurerReportPage,
  'treas/reconcile': ReconcilePage,
  'admin/board': BoardAdminPage,
  'admin/membership': MembershipPage,
  'admin/member': MemberAdminPage,
  'admin/meeting-attendance': AttendancePage,
  'admin/endorsements/election': ElectionAdminPage,
  'admin/endorsements/office-type': OfficeTypeAdminPage,
  'admin/endorsements/office': OfficeAdminPage,
  'admin/endorsements/office-holder': OfficeHolderAdminPage,
  'admin/endorsements/candidacy': CandidacyAdminPage,
  'admin/endorsements/candidate-endorsement': CandidateEndorsementPage,
  'blog': BlogIndexPage,
  'blog/story': BlogStoryPage,
  'blog/post': BlogPostPage,
};
*/

if (typeof window !== 'undefined') {
  const onResize = () => {
    store.dispatch(resizeWindow());
  };
  window.addEventListener('resize', onResize, { passive: true });
}

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <div style={{height: '100%'}}>
          <AlertContainer />
          {/*<Router {...pages} />*/}
          <Router />
        </div>
      </Provider>
    );
  }
}

export default App;

